import React from 'react';
import { Card } from '../ui/Card';
import { BookmarkIcon } from 'lucide-react';
export function LessonCreditTab() {
  return <div data-id="element-352">
      <Card title="Lesson Credits" data-id="element-353">
        <div className="flex items-center gap-3 mb-4" data-id="element-354">
          <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center" data-id="element-355">
            <BookmarkIcon className="w-5 h-5 text-green-600" data-id="element-356" />
          </div>
          <div data-id="element-357">
            <h3 className="font-medium" data-id="element-358">5 Credits Available</h3>
            <p className="text-sm text-gray-500" data-id="element-359">
              Valid until December 31, 2023
            </p>
          </div>
        </div>
        <button className="text-blue-600 hover:text-blue-800 text-sm font-medium" data-id="element-360">
          + Add Credits
        </button>
      </Card>
    </div>;
}